import styled from "styled-components";
import Select from "./Select";

export const SearchSelect = styled(Select).attrs({
    width: "135px",
    height: "32px",
    marginLeft: "8px"
})``